export const inboxLabelFrag = `
    id
    name
    color
    icon
`;
